import React from "react";
import { Box, Button } from "@agilekit/ui";
import { useTranslation } from "react-i18next";

const AppCrashFallback: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Box
			role="alert"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			minHeight="100vh"
			p={4}
			textAlign="center"
		>
			<h2>{t("appCrash.title")}</h2>
			<Box mt={2} mb={4} maxWidth={480}>
				<p>{t("appCrash.message")}</p>
			</Box>
			<Button primary onClick={() => window.location.reload()}>
				{t("appCrash.reload")}
			</Button>
		</Box>
	);
};

export default AppCrashFallback;
